import { render, staticRenderFns } from "./TheLayoutMobile.vue?vue&type=template&id=1fb07d5c&scoped=true&"
import script from "./TheLayoutMobile.vue?vue&type=script&lang=ts&"
export * from "./TheLayoutMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TheLayoutMobile.vue?vue&type=style&index=0&id=1fb07d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb07d5c",
  null
  
)

export default component.exports